module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou12-691b687212242892d4bff11509dd6c32.jpg";